import { Injectable } from '@angular/core';
import { ITypedResponse } from '@caslink/common-client';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import { IDeviceInformation, IDeviceNode } from '../shared/models/device';

@Injectable({
    providedIn: 'root'
})
export class SystemSettingsService {
    public static $name = 'systemSettingsService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getDeviceInformation(hardwareItemId: number): angular.IPromise<IDeviceNode> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getSystemInformation',
            routeParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<IDeviceNode>();
    }

    public updateDeviceInformation(device: IDeviceInformation, hardwareItemId: number): angular.IPromise<ITypedResponse<string>> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'updateSystemInformation',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<ITypedResponse<string>>().then((response: ITypedResponse<string>) => {
            return response;
        });
    }

    public saveDeviceInformationTemplate(device: IDeviceInformation, hardwareItemId: number, template: string, fullsnapshot: boolean): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'saveSystemInformationTemplate',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                templateName: template
            },
            queryParams: {
                fullSnapshot: fullsnapshot
            }
        }).as<any>().then((response: any) => {
            return response;
        });
    }

    public previewDeviceInformationTemplate(device: IDeviceInformation, hardwareItemId: number, template: string, fullsnapshot: boolean): angular.IPromise<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesViewModel> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'previewSystemInformationTemplate',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                templateName: template
            },
            queryParams: {
                fullSnapshot: fullsnapshot
            }
        }).as<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesViewModel>();
    }

    public getDeviceInformationTemplates(hardwareItemId: number): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getSystemInformationTemplates',
            routeParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<any>();
    }

    public applyDeviceInformationTemplate(device: IDeviceInformation, hardwareItemId: number, templateId: string): angular.IPromise<IDeviceNode> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'applySystemInformationTemplate',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                templateId: templateId
            }
        }).as<IDeviceNode>();
    }

    public importCaalToDeviceInformation(device: IDeviceInformation, hardwareItemId: number, documentId: number): angular.IPromise<IDeviceNode> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'importCaalToSystemInformation',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                documentId: documentId
            }
        }).as<IDeviceNode>();
    }

    public exportDeviceInformationToCaal(device: IDeviceInformation, hardwareItemId: number, documentId: number): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'exportSystemInformationToCaal',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                documentId: documentId
            }
        }).as<number>().then((response: number) => {
            return response;
        });
    }

    public getCanManageTemplates(): angular.IPromise<boolean> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getCanUseSystemInformationTemplates'
        }).as<boolean>();
    }

    public getIsCommissionerModelSupported(device: IDeviceInformation): angular.IPromise<boolean> {
        const identifier = device.$deviceHierarchy.identifier;
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'isCommissionerModelSupported',
            queryParams: {
                'viewModelIdentifier.actorType': identifier.actorType,
                'viewModelIdentifier.entityId': identifier.entityId,
                'viewModelIdentifier.entityType': identifier.entityType,
                'viewModelIdentifier.viewModelType': identifier.viewModelType,
            }
        }
        ).as<boolean>();
    }

}
